// extracted by mini-css-extract-plugin
export var changeIcon = "_5y-4";
export var container = "_5y-0";
export var divider = "_5y-7";
export var externalLinkIcon = "_5y-1";
export var green = "_5y-5";
export var helpCircleIcon = "_5y-3";
export var iconButton = "_5y-2";
export var red = "_5y-6";